import merge from 'lodash/object';
import { routerStateReducer as router } from 'redux-router';
import { routerReducer as routing } from 'react-router-redux';
import { combineReducers } from 'redux';
import {createResponsiveStateReducer} from 'redux-responsive';
import actionTypes from '../actions/actionTypes';
import snackbar from './snackbar';
import citySuggestions from './cityAutoSuggestReducer';
import searchSuggestions from './searchAutosuggestReducer';
import ReactGA from 'react-ga'


function logGAEvent(event) {
  if (typeof(window) !== "undefined") {
    ReactGA.event(event);
  }
}

function baseState(state = { categories: [], isLoaded: false, regions: [], userIP: null}, action) {
  if (action.type == 'FETCH_BASE_STATE_DONE') {
    return {
      categories: action.response.data.categories,
      regions: action.response.data.regions,
      userIP: action.response.data.userip,
      isLoaded: true
    };
  }
  return state;
}


function auth(state = { loggedIn: false, loginAttempts: 0, user: null, saved: false, isLoading: false }, action) {
   if (action.type == actionTypes.FETCH_USER) {
    return {
      loggedIn: true,
      loginAttempts: 0,
      user: null,
      saved: false,
      isLoading: true
    };
  }

  if (action.type == actionTypes.LOGIN) {
    logGAEvent({
      category: 'user',
      value: 1,
      action: 'login attempted'
    });
  }

  if(action.type == actionTypes.LOGIN_FAIL) {
    logGAEvent({
      category: 'user',
      value: 1,
      action: 'login failed'
    });
    return {
      loggedIn: false,
      user: null,
      loginAttempts: (state.loginAttempts) ? state.loginAttempts + 1: 1, saved: false,
      isLoading: false
    };
  }

  if(action.type == actionTypes.LOGOUT_REQUEST) {
    logGAEvent({
      category: 'user',
      value: 1,
      action: 'logout attempted'
    });
    let s = Object.assign({}, state);
    s.isLoading = true;
    return s;
  }

  if(action.type == actionTypes.LOGOUT_SUCCESS) {
    logGAEvent({
      category: 'user',
      value: 1,
      action: 'logged out'
    });
    return {
      loggedIn: false,
      user: null,
      loginAttempts: 0,
      saved: false,
      isLoading: false
    };
  }

  if(action.type == 'LOGIN_DONE') {
    logGAEvent({
      category: 'user',
      value: 1,
      action: 'login succeeded'
    });
    return {
      loggedIn: true,
      user: null,
      key: action.response.data.key,
      saved: false,
      isLoading: false
    };
  }

  if(action.type == 'FETCH_USER_DONE' || action.type == 'SAVE_ME_DONE' || action.type === 'UPLOAD_AVATAR_DONE') {
    if (action.type == 'SAVE_ME_DONE') {
      logGAEvent({
        category: 'user',
        value: 1,
        action: 'account edited'
      });
    }
    return {
      loggedIn: true,
      user: action.response.data,
      saved: true,
      isLoading: false
    };
  }


  if(action.type == 'FETCH_USER_FAIL') {
    let s = Object.assign({}, state);
    s.isLoading = false;
    return s;
  }

  if(action.type == 'UPDATE_MY_INTERESTS') {
    if(state.user) {
      let s = Object.assign({}, state);
      s.user.interests.categories = action.categoryIds;
      s.isLoading = false;
      return s;
    }
  }

  if(action.type == actionTypes.SAVE_USER_INFO_STEP_DONE) {
    return {
      loggedIn: true,
      user: action.response.data,
      saved: true,
      isLoading: false
    };
  }

  return state;
}


function signup(state = { error: false, message: null, nonFieldErrors: null, fieldErrors: null, key: null }, action) {
  if(action.type == actionTypes.SIGNUP_FAIL) {
    const r = action.error.response.data;
    return {
      error: true,
      message: r.errorMessage || 'Account Creation Failed!',
      fieldErrors: { email: r.email, password1: r.password1 },
      nonFieldErrors: r.non_field_errors
    };
  }

  if(action.type == actionTypes.SIGNUP_DONE) {
    logGAEvent({
      category: 'user',
      value: 1,
      action: 'signup completed'
    });
    return { error: false, key: action.response.data.key, message: null, fieldErrors: [] };
  }

  if(action.type != actionTypes.SIGNUP_FAIL) {
    logGAEvent({
      category: 'user',
      value: 1,
      action: 'logged out'
    });
    return { error: false, key: null, message: null, fieldErrors: [] };
  }

  return state;
}


function recaptcha(state = {success: false, message: '', challenge_ts: null, hostname: null}, action ) {
  if (action.response && action.type.indexOf('VERIFY_RECAPTCHA') != -1) {
    return action.response.data;
  }
  return state;
}


/**
 * Reduces response for sending verification email.
 */
function email_verification(state = { error: false, message: null, attempted: false }, action) {
  if(action.type.indexOf(actionTypes.SEND_VERIFICATION_EMAIL) != -1 &&  action.response) {
    return action.response.data;
  }

  return state;
}

function email_activation(state = {isVerifying: false, isExpired: false}, action) {
  if(action.type === actionTypes.EMAIL_VERIFICATION) {
    return {
      ...state,
      isVerifying: true,
    };
  }
  if(action.type === actionTypes.EMAIL_VERIFICATION_DONE) {
    return {
      ...state,
      isVerifying: false,
      isExpired: false,
    };
  }
  if(action.type === actionTypes.EMAIL_VERIFICATION_FAIL) {
    return {
      ...state,
      isVerifying: false,
      isExpired: true,
    };
  }
  return state;
}


/**
 * Reduces response for email verification.
 */
function verifyEmail(state = { isVerified: false, nextUrl: null, isLoading: false, isExpired: false, wasNotFound: false}, action) {
  switch (action.type) {
  case actionTypes.EMAIL_VERIFICATION:
    return {
      ...state,
      isLoading: true
    }
  case actionTypes.EMAIL_VERIFICATION_DONE:
    return {
      ...action.response.data,
      wasNotFound: false,
      isLoading: false
    }

  case actionTypes.EMAIL_VERIFICATION_FAIL:
    return {
      isVerified: false,
      nextUrl: null,
      isLoading: false,
      wasNotFound: (action.error.response.status == 404),
      isExpired: (action.error.response.status == 410)
    }
  }

  return state;
}

function userStoryDetail(state= { isLoaded: false }, action) {

  if(action.type == actionTypes.FETCH_STORY) {
    return {
      isLoaded: false
    }
  }

  if(action.response && (action.type == actionTypes.FETCH_STORY_DONE)) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  if(action.type == actionTypes.FETCH_STORY_FAIL) {
    return {
      isLoaded: false
    }
  }

  return state;
}

function sharedStoryDetail(state= { isLoaded: false }, action) {

  if(action.type == actionTypes.FETCH_SHARED_STORY) {
    return {
      isLoaded: false
    }
  }

  if(action.response && (action.type == actionTypes.FETCH_SHARED_STORY_DONE)) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  if(action.type == actionTypes.FETCH_SHARED_STORY_FAIL) {
    return {
      isLoaded: false
    }
  }

  return state;
}


function homeBannerFeaturedOrganizations(state = { results: [], isLoaded: false }, action){
  if (action.response && action.type == actionTypes.FETCH_HOME_BANNER_FEATURED_ORGANIZATIONS_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

// These are the organizations that are included in the featured regions. Fetch featured regions may have been a better choice of variable.
function featuredHomeOrganizations(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type == actionTypes.FETCH_FEATURED_HOME_ORGANIZATIONS_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}


function homeStories(state= { results: [], isLoaded: false }, action) {
  if(action.response && action.type == actionTypes.FETCH_HOMESTORIES_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    newState.storyType = 'newsStory';
    return newState;
  }

  return state;
}

function festivalNews(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type == actionTypes.FETCH_FESTIVAL_NEWS_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function festivalSponsorshipCategories(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type == actionTypes.FETCH_SPONSORSHIP_CATEGORIES_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }
  return state;
}

function festivalSponsorsByCategory(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type == actionTypes.FETCH_FESTIVAL_SPONSOR_BY_CATEGORY_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }
  return state;
}

function organizations(state = { results: [] , count: null, next: null, previous: null, isLoaded: false }, action) {
  if(action.response && action.type == actionTypes.FETCH_ORGANIZATIONS_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function favoriteOrganizations(state = { results: [] , count: null, next: null, previous: null, isLoaded: false }, action) {
  if(action.response && action.type == actionTypes.FETCH_FAVORITE_ORGANIZATIONS_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }
  return state;
}

function organization(state = { isLoading: false }, action) {
  if(action.type == actionTypes.FETCH_ORGANIZATION) {
    return { isLoading: true };
  }
  if(action.response && (action.type == actionTypes.FETCH_ORGANIZATION_DONE||  action.type == actionTypes.SAVE_ORGANIZATION_DONE)) {
    const organization = action.response.data;
    return {isLoading: false, ...organization };
  }
  if(action.type == actionTypes.FETCH_ORGANIZATION_FAIL) {

    return {isLoading: false, wasNotFound: (action.error.response.status === 404) ? true : false};
  }

  return state;
}


function regions(state = { regions: [], isLoaded: false }, action) {
  if(action.response && action.type == actionTypes.FETCH_REGIONS_DONE) {
    state = { isLoaded: true };
    state.regions = action.response.data.regions;
    return state;
  }
  return state;
}


function mySuggestions(state = { organizations: { results: [] }, isLoading: false, error: false }, action) {
  if(action.response && action.type == actionTypes.FETCH_MY_SUGGESTIONS_DONE) {
    return {
      organizations: action.response.data,
      isLoading: false,
      error: false
    }
  }
  if (action.response && action.type == actionTypes.FETCH_MY_SUGGESTIONS) {
    return {
      organizations: { results:  [] },
      isLoading: true
    }
  }
  if (action.response && action.type == actionTypes.FETCH_MY_SUGGESTIONS_FAIL) {
    return {
      organizations: { results:  [] },
      isLoading: false,
      error: true
    }
  }
  return state
}

function organizationClaim(state = {isLoading: false}, action) {
  if(action.type == actionTypes.FETCH_ORGANIZATION_CLAIM) {
    return { isLoading: true};
  }

  if(action.response && action.type == actionTypes.FETCH_ORGANIZATION_CLAIM_DONE) {
    const claim = action.response.data;
    return { isLoading: false, ...claim };
  }

  if(action.type == actionTypes.FETCH_ORGANIZATION_CLAIM_FAIL) {
    return { isLoading: false };
  }

  if(action.response && action.type == actionTypes.SAVE_ORGANIZATION_CLAIM_DONE) {
    logGAEvent({
      category: 'organizations',
      value: 1,
      action: 'new claim'
    });
    const claim = action.response.data;
    return { isLoading: false, ...claim };
  }

  if(action.error && action.type == actionTypes.SAVE_ORGANIZATION_CLAIM_FAIL) {
    let newState = {isLoading: false};
    newState.error =  true;
    newState.errors = action.error.response.data;
    return newState;
  }

  return state;
}


function temporal(state = {}, action) {
  if(action.type == "SAVE_RECOMMENDED_RESOURCE_DONE") {
    logGAEvent({
      category: 'user',
      value: 1,
      action: 'recommended organization'
    });
    return { recommendedResourceSaved: true };
  }

  if(action.type == "SAVE_MY_INTERESTS_DONE") {
    logGAEvent({
      category: 'user',
      value: 1,
      action: 'edited interests'
    });
    return { myInterestsSaved: true };
  }

  return state;
}

function myInterests(state = { categoryIds: [], isLoaded: false }, action) {
  if(action.type == 'FETCH_MY_INTERESTS_DONE') {
    return { categoryIds: action.response.data.categories, isLoaded: true };
  }

  if(action.type == 'UPDATE_MY_INTERESTS') {
    return { categoryIds: action.categoryIds, isLoaded: true };
  }

  return state;
}

function myFavorites(state = [], action) {
  if(action.response && action.type == actionTypes.FETCH_MY_FAVORITES_DONE) {
    let favorites = action.response.data;
    return favorites;
    let organizationIds = [];
    organizationIds = favorites.map(item => {
      return item.organization;
    });

    return {
      favorites: favorites,
      organizationIds: organizationIds
    };
  }
  return state;
}



function applyOrganization(state = { saved: false }, action) {
  if(action.type == actionTypes.SAVE_ORGANIZATION_APPLICATION_DONE) {
    logGAEvent({
      category: 'organizations',
      value: 1,
      action: 'new organization applied'
    });
    return {
      saved: true
    };
  }
  return state;
}

function applyBFWOrganization(state = { saved: false }, action) {
  if(action.type == actionTypes.SAVE_BFW_APPLICATION_DONE) {

    let newState = action.response.data;
    newState.saved = true;
    return newState;
  }
  return state;
}


function enginesOn(state = false , action) {
  const actionType = action.type;
  const shouldShow = (
    actionType.indexOf('_DONE') == -1 &&
    actionType.indexOf('_FAIL') == -1 &&
    actionType.indexOf('LOCATION_CHANGE') == -1 &&
    actionType.indexOf('RESPONSIVE_STATE') == -1 &&
    actionType.indexOf('MY_INTERESTS') == -1 &&
    actionType.indexOf('REGION_FILTER') == -1 &&
    actionType.indexOf('_SUCCESS') == -1 &&
    actionType.indexOf('_FAILURE') == -1 &&
    actionType.indexOf('_REQUEST') == -1
  );
  return shouldShow;
}


function categoryBannerSliderCollection(state = { items: [] }, action) {
  if(action.type == actionTypes.FETCH_CATEGORY_BANNER_SLIDER_COLLECTION_FAIL) {
    return {
      items: []
    };
  }

  if(action.response && action.type == actionTypes.FETCH_CATEGORY_BANNER_SLIDER_COLLECTION_DONE) {
    return {
      items: action.response.data.items
    };
  }

  return state;
}

function notifications(state = [], action) {
  if(action.response && action.type == actionTypes.FETCH_NOTIFICATIONS_DONE) {
    return action.response.data;
  }
  return state;
}

function notificationDetail(state = {}, action) {
  if(action.response && action.type == actionTypes.FETCH_NOTIFICATION_DONE) {
    return action.response.data;
  }
  return state;
}


function categoryLPFilter(state = { regions: [], global: false}, action) {
  if(action.type == actionTypes.UPDATE_REGION_FILTER) {
    if(action.regionId) {
      let regionIds = state.regions;
      let regionId = Number(action.regionId);
      let idx = regionIds.indexOf(regionId);

      if (idx == -1) {
        regionIds.push(regionId);
      }
      else {
        let t = regionIds.splice(idx, 1);
      }

      return { regions: regionIds, global: state.global, regionalIds: regionIds };
    }

    if(action.global) {
      let s = { regions: state.regions, global: !state.global };
      return s;
    }
  }


  return state;
}


function featuredOrganizations(state = [], action) {
  if(action.response && action.type == actionTypes.FETCH_FEATURED_ORGANIZATIONS_DONE) {
    return action.response.data.results.slice(0, 4);
  }
  return state;
}

function collageOrganizations(state = [], action) {
  if(action.response && action.type == actionTypes.FETCH_COLLAGE_ORGANIZATIONS_DONE) {
    return action.response.data;
  }
  return state;
}

function flatPages(state = {pages: [], isLoading: false }, action) {
  if(action.type == actionTypes.FETCH_FLATPAGES) {
    return {
      pages: [],
      isLoading: true
    };
  }

  if(action.response && action.type == actionTypes.FETCH_FLATPAGES_DONE) {
    return {
      pages: action.response.data.results,
      isLoading: false
    };
  }

  if(action.response && action.type == actionTypes.FETCH_FLATPAGES_FAIL) {
    return {
      pages: [],
      isLoading: false
    };
  }

  return state;
}

function keywordSearchResults(state = { results: [] , count: null, next: null, previous: null, isLoaded: false }, action) {
  if(action.response && action.type == actionTypes.FETCH_KEYWORD_SEARCH_RESULTS) {
    logGAEvent({
      category: 'search',
      value: 1,
      action: 'keyword search attempted'
    });
    return { isLoaded: false, results: [], count: 0 }
  }

  if(action.response && action.type == actionTypes.FETCH_KEYWORD_SEARCH_RESULTS_DONE) {
    logGAEvent({
      category: 'search',
      value: 1,
      action: 'keyword search succeeded'
    });
    let newState = action.response.data;
    newState.isLoaded = true ;
    return newState;
  }

  if(action.response && action.type == actionTypes.FETCH_KEYWORD_SEARCH_RESULTS_FAIL) {
    logGAEvent({
      category: 'search',
      value: 1,
      action: 'keyword search failed'
    });
    return { isLoaded: false, results: [], count: 0 }
  }

  return state;
}


function autoRegion(state = { longitude: null, latitude: null, city: null, state: null, country: null }, action) {
  switch (action.type) {

  case actionTypes.BROWSER_GEOLOCATION_SUCCESS:
    const position = action.payload;
    return {
      longitude: position.longitude,
      latitude: position.latitude,
      city: null,
      state: null,
      country: null
    };

  case action.BROWSER_GEOLOCATION_FAILURE:
    return {
      longitude: null,
      latitude: null,
      city: null,
      state: null,
      country: null
    };
  }

  return state;
}

function resetPassword(state = {email: null}, action) {
  switch (action.type) {
    case actionTypes.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        email: action.email
      };
    default:
      return state;
  }
}

function bfwOrganizations(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type == actionTypes.FETCH_BFW_ORGANIZATIONS_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function featuredOrgsSlider(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type == actionTypes.FETCH_FEATURED_ORGS_SLIDER_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function orgsByType(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type == actionTypes.FETCH_ORGS_BY_TYPE_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function girlsFestivalEventCategories(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type==actionTypes.FETCH_FESTIVAL_EVENT_CATEGORIES_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function girlsFestivalEventsByCategory(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type==actionTypes.FETCH_FESTIVAL_EVENTS_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function girlsFestivalProgramEventsByCategory(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type==actionTypes.FETCH_FESTIVAL_PROGRAM_EVENTS_BY_CATEGORY_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function girlsFestivalProgramLP(state = { results: [], isLoaded: false }, action) {
  if (action.response && action.type==actionTypes.FETCH_FESTIVAL_PROGRAM_LP_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function girlsFestivalCategoryEvents(state = { results: [], isLoaded: false}, action) {
  if (action.response && action.type==actionTypes.FETCH_CATEGORY_EVENTS_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function girlsFestivalTimesEvents(state = { results: [], isLoaded: false}, action) {
  if (action.response && action.type==actionTypes.FETCH_TIMES_EVENTS_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}


function authForm(state = { type: null, payload: {next: null, flow: null}}, action) {
  switch (action.type) {
  case actionTypes.OPEN_SIGNUP_FORM_REQUEST:
    return { type: 'signup', payload: action.payload };
  case actionTypes.CLOSE_SIGNUP_FORM_REQUEST:
    return { type: null, payload: {next: null, flow: null} };
  case actionTypes.OPEN_LOGIN_FORM_REQUEST:
    return { type: 'login', payload: action.payload };
  case actionTypes.CLOSE_LOGIN_FORM_REQUEST:
    return { type: null, payload: {next: null, flow: null} };
  }
  return state;
}

function bfwOffers(state = { results: [], isLoaded: false}, action) {
  if (action.response && action.type==actionTypes.FETCH_BFW_OFFERS_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function bfwOffersFeatured(state = { results: [], isLoaded: false}, action) {
  if (action.response && action.type==actionTypes.FETCH_BFW_OFFERS_FEATURED_DONE) {
    let newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }

  return state;
}

function leaderStorySaved(state = { saved: false, isLoading: true }, action) {
  let newState = {};
  if(action.type == actionTypes.SAVE_LEADER_STORY_DONE) {
    newState = action.response.data;
    newState.saved = true;
    newState.isLoading = false;
    return newState;
  }
  return state;
}

function sharedStory(state = { saved: false, isLoading: true }, action) {
  let newState = {};
  if(action.type == actionTypes.SAVE_SHARED_STORY_DONE) {
    newState = action.response.data;
    newState.saved = true;
    newState.isLoading = false;
    return newState;
  }

  if(action.type == actionTypes.UPLOAD_SHARED_STORY_PHOTO_DONE) {
    newState = action.response.data;
    newState.isLoading = false;
    return newState;
  }
  return state;
}

function sharedStories(state = { isLoaded:false }, action) {
  let newState = {};
  if(action.type == actionTypes.FETCH_SHARED_STORIES_DONE) {
    newState = action.response.data;
    newState.isLoaded = true;
    newState.storyType = 'sharedStory';
    return newState;
  }
  return state;
}

function storiesByCategory(state = { isLoaded:false }, action) {
  let newState = {};
  if(action.type == actionTypes.FETCH_STORIES_BY_CATEGORY_DONE) {
    newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }
  return state;
}

function storiesByCategoryRoot(state = { isLoaded:false }, action) {
  let newState = {};
  if(action.type == actionTypes.FETCH_STORIES_BY_CATEGORY_ROOT_DONE) {
    newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }
  return state;
}

function storiesCategoryNames(state = { isLoaded:false }, action) {
  let newState = {};
  if(action.type == actionTypes.FETCH_STORY_CATEGORY_NAMES_DONE) {
    newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }
  return state;
}

function girlsFestivalSponsors(state = { isLoaded: false }, action) {
  let newState = {};
  if(action.type == actionTypes.FETCH_SPONSORS_DONE) {
    newState = action.response.data;
    newState.isLoaded = true;
    return newState;
  }
  return state;
}



function featuredOrgFromDB(state = { isLoading: true }, action) {
  let newState = {};
  if(action.type == actionTypes.FETCH_FEATURED_ORGS_FROM_DB_DONE) {
    newState = action.response.data;
    newState.isLoading = false;
    return newState;
  }

  return state;
}

function homePageCategories(state = { isLoading: true }, action) {
  let newState = {};
  if(action.type == actionTypes.FETCH_HOME_PAGE_CATEGORIES_DONE) {
    newState = action.response.data;
    newState.isLoading = false;
    return newState;
  }

  return state;
}

function homePageNewsletters(state = { isLoading: true }, action) {
  let newState = {};
  if(action.type == actionTypes.FETCH_HOME_PAGE_NEWSLETTERS_DONE) {
    newState = action.response.data;
    newState.isLoading = false;
    return newState;
  }

  return state;
}

function getNewsletter(state = { isLoading: true }, action) {
  let newState = {};
  if(action.type == actionTypes.FETCH_NEWSLETTER_DONE) {
    newState = action.response.data;
    newState.isLoading = false;
    return newState;
  }

  return state;
}



const rootReducer = combineReducers({
  browser: createResponsiveStateReducer({
    mobile: 400,
    phablet: 550,
    tablet: 750,
    tabletLandscape: 1024,
    desktop: 1200,
    desktophd: 1800
  }),
  snackbar,
  baseState,
  resetPassword,
  auth,
  signup,
  email_verification,
  email_activation,
  organizations,
  favoriteOrganizations,
  organization,
  organizationClaim,
  regions,
  mySuggestions,
  myInterests,
  myFavorites,
  applyOrganization,
  temporal,
  enginesOn,
  categoryBannerSliderCollection,
  notifications,
  notificationDetail,
  categoryLPFilter,
  featuredOrganizations,
  collageOrganizations,
  flatPages,
  recaptcha,
  keywordSearchResults,
  citySuggestions,
  searchSuggestions,
  verifyEmail,
  routing,
  homeStories,
  userStoryDetail,
  featuredHomeOrganizations,
  homeBannerFeaturedOrganizations,
  bfwOrganizations,
  applyBFWOrganization,
  girlsFestivalCategoryEvents,
  girlsFestivalTimesEvents,
  girlsFestivalEventCategories,
  girlsFestivalEventsByCategory,
  girlsFestivalProgramEventsByCategory,
  girlsFestivalProgramLP,
  festivalSponsorshipCategories,
  festivalSponsorsByCategory,
  authForm,
  bfwOffers,
  bfwOffersFeatured,
  leaderStorySaved,
  sharedStory,
  sharedStories,
  sharedStoryDetail,
  festivalNews,
  featuredOrgsSlider,
  orgsByType,
  storiesByCategory,
  storiesCategoryNames,
  storiesByCategoryRoot,
  girlsFestivalSponsors,
  featuredOrgFromDB,
  homePageCategories,
  homePageNewsletters,
  getNewsletter,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js